const KEY = "nx_cart";
export const CART_EVENT = "nx-cart";

export const getCart = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

const save = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent(CART_EVENT));
};

export const cartCount = () => getCart().reduce((s, i) => s + i.qty, 0);
export const cartIds = () => getCart().map((i) => i.id);

export const addToCart = (p, qty = 1) => {
  const items = getCart();
  const ex = items.find((i) => i.id === p.id);
  if (ex) ex.qty = Math.min(20, ex.qty + qty);
  else items.push({ id: p.id, name: p.name, price_inr: p.price_inr, qty: Math.min(20, qty) });
  save(items);
};

export const setQty = (id, qty) => {
  if (qty <= 0) return removeItem(id);
  save(getCart().map((i) => (i.id === id ? { ...i, qty: Math.min(20, qty) } : i)));
};

export const removeItem = (id) => save(getCart().filter((i) => i.id !== id));
export const clearCart = () => save([]);
